/**
 * collection-mobile-bar.js
 * - Keeps the sticky Filter/Sort bar right under the (sticky) site header by publishing the header's
 *   current height as --hom-sticky-top.
 * - "Sort" in the bar opens the same drawer as "Filter" and scrolls the drawer to the sort control.
 */
(function () {
  "use strict";
  var root = document.documentElement;
  var ticking = false;

  function setTop() {
    ticking = false;
    var h = document.getElementById("shopify-section-header");
    var top = 0;
    if (h) {
      var cs = getComputedStyle(h);
      if (cs.position === "sticky" || cs.position === "fixed") top = Math.max(0, Math.round(h.getBoundingClientRect().bottom));
    }
    root.style.setProperty("--hom-sticky-top", top + "px");
  }
  function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(setTop); } }
  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule);
  window.addEventListener("load", schedule);
  document.addEventListener("DOMContentLoaded", schedule);
  schedule();

  // raise the whole bar above the header only while the filter drawer is open
  document.addEventListener("toggle", function (e) {
    var d = e.target;
    if (!d || !d.classList || !d.classList.contains("mobile-facets__disclosure")) return;
    var wrap = d.closest(".mobile-facets__wrapper");
    if (wrap) wrap.classList.toggle("is-drawer-open", d.open);
  }, true);

  document.addEventListener("click", function (e) {
    var sortBtn = e.target.closest && e.target.closest(".mf-bar__sort");
    if (!sortBtn) return;
    setTimeout(function () {
      var target = document.querySelector(".mobile-facets__wrapper details[open] .mobile-facets__sort");
      if (target) target.scrollIntoView({ block: "center" });
    }, 400);
  });
})();
